import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getDistricts(filter) {
  try {
    let res = await http.get('/District');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function getDistrictGroups(filter) {
  try {
    let res = await http.get('/DistrictGroup');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateDistrictGroup(id, data) {
  try {
    const res = await http.put(`/DistrictGroup/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewDistrictGroup(data) {
  try {
    const res = await http.post('DistrictGroup', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
